import * as React from 'react';
const SvgThumbsUpSmall = (props) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_18233_23019)">
      <path
        d="M3.14218 11.1781H1.64945C1.38552 11.1781 1.1324 11.0732 0.94577 10.8866C0.759143 10.7 0.654297 10.4469 0.654297 10.1829V6.6999C0.654297 6.43597 0.759143 6.18285 0.94577 5.99622C1.1324 5.8096 1.38552 5.70475 1.64945 5.70475H3.14218M6.62521 4.7096V2.71929C6.62521 2.3234 6.46795 1.94371 6.188 1.66377C5.90806 1.38383 5.52838 1.22656 5.13249 1.22656L3.14218 5.70475V11.1781H8.75484C8.99484 11.1808 9.22773 11.0967 9.4106 10.9412C9.59347 10.7858 9.71401 10.5695 9.75 10.3322L10.4367 5.85402C10.4583 5.7114 10.4487 5.56577 10.4085 5.42723C10.3682 5.28869 10.2984 5.16055 10.2037 5.05169C10.1091 4.94283 9.99186 4.85585 9.86024 4.79678C9.72863 4.73771 9.58575 4.70796 9.4415 4.7096H6.62521Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5217 8.30335V6.31304C11.5217 5.91715 11.3644 5.53746 11.0845 5.25752C10.8045 4.97758 10.4249 4.82031 10.029 4.82031L8.03866 9.2985V14.7718H13.6513C13.8913 14.7746 14.1242 14.6904 14.3071 14.535C14.49 14.3796 14.6105 14.1633 14.6465 13.926L15.3331 9.44777C15.3548 9.30515 15.3452 9.15952 15.3049 9.02098C15.2647 8.88244 15.1949 8.7543 15.1002 8.64544C15.0055 8.53658 14.8883 8.4496 14.7567 8.39053C14.6251 8.33146 14.4822 8.30171 14.338 8.30335H11.5217ZM8.03866 14.7718H6.54593C6.282 14.7718 6.02888 14.667 5.84225 14.4804C5.65563 14.2937 5.55078 14.0406 5.55078 13.7767V10.2937C5.55078 10.0297 5.65563 9.7766 5.84225 9.58997C6.02888 9.40335 6.282 9.2985 6.54593 9.2985H8.03866"
        fill="white"
      />
      <path
        d="M8.03866 14.7718H6.54593C6.282 14.7718 6.02888 14.667 5.84225 14.4804C5.65563 14.2937 5.55078 14.0406 5.55078 13.7767V10.2937C5.55078 10.0297 5.65563 9.7766 5.84225 9.58997C6.02888 9.40335 6.282 9.2985 6.54593 9.2985H8.03866M11.5217 8.30335V6.31304C11.5217 5.91715 11.3644 5.53746 11.0845 5.25752C10.8045 4.97758 10.4249 4.82031 10.029 4.82031L8.03866 9.2985V14.7718H13.6513C13.8913 14.7746 14.1242 14.6904 14.3071 14.535C14.49 14.3796 14.6105 14.1633 14.6465 13.926L15.3331 9.44777C15.3548 9.30515 15.3452 9.15952 15.3049 9.02098C15.2647 8.88244 15.1949 8.7543 15.1002 8.64544C15.0055 8.53658 14.8883 8.4496 14.7567 8.39053C14.6251 8.33146 14.4822 8.30171 14.338 8.30335H11.5217Z"
        stroke="currentColor"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_18233_23019">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgThumbsUpSmall;
